import { AgendaItemStatusEnum } from "enums/AgendaItemStatusEnum";
import { NumberChoiceModel } from "models/ChoiceModel";
import { TranslationsContextProps } from "providers";

export function getAgendaItemStatuses(i18n: TranslationsContextProps): NumberChoiceModel[] {
  return [
    {
      value: AgendaItemStatusEnum.Unknown,
      name: AgendaItemStatusEnum[AgendaItemStatusEnum.Unknown],
      text: i18n.AgendaItemStatus_Unknown,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: AgendaItemStatusEnum.Default,
      name: AgendaItemStatusEnum[AgendaItemStatusEnum.Default],
      text: i18n.AgendaItemStatus_Default,
      tooltip: "",
      disabled: false,
      isDefault: true,
    },
    {
      value: AgendaItemStatusEnum.Approved,
      name: AgendaItemStatusEnum[AgendaItemStatusEnum.Approved],
      text: i18n.AgendaItemStatus_Approved,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: AgendaItemStatusEnum.Published,
      name: AgendaItemStatusEnum[AgendaItemStatusEnum.Published],
      text: i18n.AgendaItemStatus_Published,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: AgendaItemStatusEnum.Finalized,
      name: AgendaItemStatusEnum[AgendaItemStatusEnum.Finalized],
      text: i18n.AgendaItemStatus_Finalized,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: AgendaItemStatusEnum.Archived,
      name: AgendaItemStatusEnum[AgendaItemStatusEnum.Archived],
      text: i18n.AgendaItemStatus_Archived,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: AgendaItemStatusEnum.Deleted,
      name: AgendaItemStatusEnum[AgendaItemStatusEnum.Deleted],
      text: i18n.AgendaItemStatus_Deleted,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
  ];
}
